<style>

a {
		color: #d06bff;
		text-decoration: none; /* no underline */
		-webkit-text-stroke: 1px rgba(0, 0, 0, 0.253);
		/* -webkit-text-stroke: 1px rgba(78, 78, 78, 0.253); */
}

	.nav-bar {
		color: #d06bff;
		background-color: rgba(142, 163, 233, 0.698);
		text-align: center;
		font-family: 'Fredoka One', cursive;
		font-size: 46pt;
		font-weight: bolder;
		letter-spacing: 6px;

		height: 100px;
		margin-bottom: 10%;


		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}
</style>

<script>
	import { fly } from 'svelte/transition';
	import NameBox from './NameBox.svelte';
	import ProfileImg from './ProfileImg.svelte';
	import QuizBox from './QuizBox.svelte';

	let part = 0
	let username = ''
	let userID = '4'

	function nextPart() {
		part = (part + 1) % 3
	}

</script>


<div class="nav-bar">
	<a href="http://localhost:5000">
		<h1>MATHOFUN</h1>
	</a>
</div>

{#if part === 0}
<div>
	<NameBox nextPart={nextPart} bind:uName={username} />
</div>
{:else if part === 1}
<div in:fly={{x: 600}}>
	<ProfileImg nextPart={nextPart} uName={username} bind:uID={userID} />
</div>
{:else if part === 2}
<div in:fly={{ x: 600 }}>
	<QuizBox uID={userID} />
</div>
{/if}

<!-- <button on:click={nextPart}>{userID}</button> -->